import { Outlet } from "react-router-dom"
import { Card, CardContent } from "@/components/ui/card"

export function AuthLayout() {
  return (
    <div className="flex min-h-screen">
      {/* Left panel — branded illustration */}
      <div className="relative hidden w-1/2 flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-primary via-emerald-600 to-teal-800 p-12 lg:flex">
        {/* Floating decorative circles */}
        <div className="absolute -left-16 -top-20 h-64 w-64 rounded-full bg-white/5" />
        <div className="absolute -bottom-12 -right-20 h-80 w-80 rounded-full bg-white/5" />
        <div className="absolute right-24 top-1/4 h-40 w-40 rounded-full bg-white/[0.03]" />
        <div className="absolute bottom-1/3 left-10 h-28 w-28 rounded-full bg-white/[0.04]" />

        {/* Illustration + text */}
        <div className="relative z-10 flex max-w-md flex-col items-center text-center">
          {/* Inline SVG illustration */}
          <svg
            viewBox="0 0 280 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mb-10 h-48 w-auto"
          >
            {/* Large circle — completeness */}
            <circle cx="140" cy="100" r="80" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" />
            {/* Inner arc */}
            <path
              d="M80 100 Q110 50 140 60 Q170 70 200 100"
              stroke="white"
              strokeOpacity="0.35"
              strokeWidth="1.5"
              fill="none"
            />
            {/* Graduation cap outline */}
            <polygon
              points="140,42 170,56 140,70 110,56"
              stroke="white"
              strokeOpacity="0.85"
              strokeWidth="1.5"
              fill="white"
              fillOpacity="0.1"
            />
            <line x1="140" y1="70" x2="140" y2="84" stroke="white" strokeOpacity="0.7" strokeWidth="1.5" />
            <path
              d="M140 84 Q140 90 148 90"
              stroke="white"
              strokeOpacity="0.5"
              strokeWidth="1.5"
              fill="none"
            />
            {/* Connected nodes — network */}
            <circle cx="90" cy="130" r="4" fill="white" fillOpacity="0.7" />
            <circle cx="140" cy="150" r="5" fill="white" fillOpacity="0.8" />
            <circle cx="190" cy="125" r="4" fill="white" fillOpacity="0.7" />
            <circle cx="170" cy="160" r="3" fill="white" fillOpacity="0.5" />
            {/* Connecting lines */}
            <line x1="90" y1="130" x2="140" y2="150" stroke="white" strokeOpacity="0.3" strokeWidth="1.5" />
            <line x1="140" y1="150" x2="190" y2="125" stroke="white" strokeOpacity="0.3" strokeWidth="1.5" />
            <line x1="140" y1="150" x2="170" y2="160" stroke="white" strokeOpacity="0.25" strokeWidth="1.5" />
            <line x1="190" y1="125" x2="170" y2="160" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" />
            {/* Gentle curved path */}
            <path
              d="M60 160 Q100 120 140 130 Q180 140 220 110"
              stroke="white"
              strokeOpacity="0.15"
              strokeWidth="1.5"
              fill="none"
            />
          </svg>

          <h2 className="text-2xl font-semibold text-white">
            Pilotez votre certification Qualiopi
          </h2>
          <p className="mt-3 text-base text-white/70">
            Formation, conformité, commercial — tout en un.
          </p>

          {/* Feature pills */}
          <div className="mt-10 flex flex-wrap gap-3" data-test="auth-claims">
            <span className="rounded-full bg-white/15 px-3 py-1 text-sm text-white backdrop-blur">
              Référentiel national qualité
            </span>
            <span className="rounded-full bg-white/15 px-3 py-1 text-sm text-white backdrop-blur">
              Hébergé en France
            </span>
            <span className="rounded-full bg-white/15 px-3 py-1 text-sm text-white backdrop-blur">
              Plan gratuit permanent
            </span>
            <span className="rounded-full bg-white/15 px-3 py-1 text-sm text-white backdrop-blur">
              Pensé pour Qualiopi
            </span>
          </div>
        </div>
      </div>

      {/* Right panel — form */}
      <div className="flex w-full items-center justify-center bg-background p-6 lg:w-1/2 lg:p-12">
        <div className="w-full max-w-md animate-fade-in">
          {/* Logo */}
          <div className="mb-8 text-center">
            <div className="mb-4 flex justify-center">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary shadow-card">
                <span className="text-base font-bold text-primary-foreground">Q</span>
              </div>
            </div>
            <h1 className="text-2xl font-semibold tracking-tight text-foreground">
              Qualneo
            </h1>
          </div>

          {/* Form — card on mobile, bare on desktop.
              The Outlet must be rendered ONCE; otherwise the child component appears
              twice in the DOM (one per breakpoint clone) and tests that match data-test
              attributes get strict-mode violations. */}
          <Card className="rounded-xl shadow-card lg:border-0 lg:bg-transparent lg:shadow-none">
            <CardContent className="pt-6 lg:p-0">
              <Outlet />
            </CardContent>
          </Card>

          <p className="mt-6 text-center text-xs text-muted-foreground">
            © {new Date().getFullYear()} Qualneo. Tous droits réservés.
          </p>
        </div>
      </div>
    </div>
  )
}
